import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Modal from '@ilg-totallymoney/ui/components/Modal'

import MinimumCreditLimitModalFormWrapper from './components/MinimumCreditLimitModalFormWrapper'

interface MinimumCreditLimitModalProps {
    onModalClose: () => void
    onSubmit?: () => void
    showModal: boolean
}

const MinimumCreditLimitModal = ({
    showModal,
    onModalClose,
    onSubmit,
}: MinimumCreditLimitModalProps) => {
    return (
        <Modal isFullScreen={true} isOpen={showModal} onClose={onModalClose}>
            <Flex justifyContent="center">
                <Box maxWidth="384px">
                    <MinimumCreditLimitModalFormWrapper
                        onModalClose={onModalClose}
                        onSubmit={onSubmit}
                    />
                </Box>
            </Flex>
        </Modal>
    )
}

export default MinimumCreditLimitModal
